import { createAuthClient } from "better-auth/react";
import { createAdminApiUrl } from "./api-url";

/**
 * Googleサインイン専用の認証クライアント
 */
export const authClient = createAuthClient({
  baseURL: createAdminApiUrl(),
  basePath: "/v1/admin/auth",
  fetchOptions: {
    credentials: "include",
  },
});
